import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { FilterContext } from "@/pages/dashboard/components/PageContainer/context";
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import moment from 'moment';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';
import { ICountryComparisonServiceProps, IRequestParams } from './type';

const CountryComparisonService: React.FC<ICountryComparisonServiceProps> = (props) => {
  const { style, className, type, config, children, data: propsData, ...restProps } = props || {};
  const { api, dataKey, refreshKey = '', interval, initMetric } = config || {};
  // const historyParam: any = history?.location?.state;
  // const jumpMetric = historyParam ? JSON.parse(historyParam)?.indicators : undefined;
  // const isInit = useRef(true);

  const  { filterVal } = useContext(FilterContext);
  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
  }), shallowEqual);

  const data = useMemo(() => ({
    gameCode,
    ...(propsData || {}),
    // metric: isInit?.current ? (jumpMetric || propsData?.metric) : propsData?.metric,
  }), [gameCode, propsData]);

  const beforeRequest = (data: any) => {
    const { filterVal, gameCode, metric } = data;
    const { timeType, rangeTime, diff, ...filters } = filterVal || {};
    // isInit.current = false;
    // Fallback filter parameters
    const params: IRequestParams = {
      game_code: gameCode,
      start_time: moment(rangeTime?.[0]).format('YYYY-MM-DD'),
      end_time: moment(rangeTime?.[1]).format('YYYY-MM-DD'),
      period: PERIODTIMEOBJ[timeType],
      metric: metric || '',
      filters: formatFilterValues(filters),
    };

    return params;
  };

  return (
    <div className={className} style={style}>
      {/* @ts-ignore */}
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        refreshKey={refreshKey}
        interval={interval}
        beforeRequest={beforeRequest}
        trackData={['gameCode', 'metric']}
      >
        {
          React.Children.map(children, (child: any) => React.cloneElement(
            child,
            {
              filterVal,
              ...restProps,
              state: {},
              initMetric,
            }
          ))
        }
      </Service>
    </div>
  );
};

export default CountryComparisonService;